import React from 'react';
import stringHelper from '../../../../Helpers/stringHelper';
import TpWaveService from '../../../../Services/TpWaveService';
import ErrorMessage from '../../../ErrorMessage';
import SelectFieldCheckbox from './SelectFieldCheckbox';

export default class TpWaveSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    idFilter: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [] });
      return;
    }

    TpWaveService.GetWaveSelectList(this.props.idFilter)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.thirdPartyWaveName > b.thirdPartyWaveName ? 1 : -1))
          .forEach((wave) => {
            optValues.push({
              label: wave.thirdPartyWaveName + stringHelper.toBracket(wave.thirdPartyWaveId),
              value: wave.tpWaveId,
              disabled: false,
            });
          });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('TWS56');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
